let cachedResult;
export function doesSupportTouchActionNone() {
  if (cachedResult === undefined) {
    const element = document.createElement('div');
    element.style.touchAction = 'none';
    document.body.appendChild(element);
    cachedResult = window.getComputedStyle(element).touchAction === 'none';
    element.parentElement.removeChild(element);
  }
  return cachedResult;
}